import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import PublishModal from '../../../DialogModal/PublishModal/PublishModal';
import DeleteModal from '../../../DialogModal/DeleteModal/DeleteModal';
import AccordionRowContainer from '../../../AccordionRow/AccordionRowContainer';
import EditInstitutionIdTypeContainer from './EditInstitutionIdType/EditInstitutionIdTypeContainer';

const InstitutionIdTypeAccordion = styled(AccordionRowContainer)`
  border-bottom: 1px solid ${props => props.theme.colors.grey[300]};
`;

const Layout = styled.div`
  width: 100%;
`;

const InstitutionIdType = ({
  institutionIdType,
  toggleEditView,
  view,
  isPublishModalOpen,
  isDeleteModalOpen,
  handlePublishModalOpen,
  handlePublishModalClose,
  handleDeleteClick,
  handleDeleteModalClose,
  handleConfirmDelete,
  onPublish
}) => {
  const institutionIdTypeActions = [
    {
      label: 'Edit',
      onClick: toggleEditView,
      shouldOpenOnClick: false,
      icon: 'edit'
    },
    {
      label: 'Publish',
      onClick: handlePublishModalOpen,
      shouldOpenOnClick: false,
      icon: 'edit'
    },
    {
      label: 'Delete',
      onClick: handleDeleteClick,
      shouldOpenOnClick: false,
      icon: 'delete'
    }
  ];

  return (
    <Layout>
      <PublishModal
        isModalOpen={isPublishModalOpen}
        handleModalClose={handlePublishModalClose}
        handlePublish={onPublish}
        entityLabel="Institution ID Type"
        publishConfirmMessage="This will make the ID type available to other XComP systems and it will be locked from deletion."
      />
      <DeleteModal
        modalOpen={isDeleteModalOpen}
        handleModalClose={() => handleDeleteModalClose()}
        handleDelete={() => handleConfirmDelete()}
        type="Institution ID Type"
      />
      {view === 'EDIT' ? (
        <EditInstitutionIdTypeContainer
          institutionIdType={institutionIdType}
          key={institutionIdType.uuid}
          toggleEditView={toggleEditView}
        />
      ) : (
        <InstitutionIdTypeAccordion
          columnOne={institutionIdType.name}
          columnTwo=""
          actions={institutionIdTypeActions}
          columnGutters="1.5rem"
          isPublished={institutionIdType.published}
          isTopLevel
          leaf
        />
      )}
    </Layout>
  );
};

InstitutionIdType.propTypes = {
  view: PropTypes.oneOf(['EDIT', '']),
  institutionIdType: PropTypes.object.isRequired,
  isPublishModalOpen: PropTypes.bool,
  isDeleteModalOpen: PropTypes.bool,
  onPublish: PropTypes.func,
  handlePublishModalOpen: PropTypes.func,
  handlePublishModalClose: PropTypes.func,
  handleDeleteClick: PropTypes.func,
  handleDeleteModalClose: PropTypes.func,
  handleConfirmDelete: PropTypes.func,
  toggleEditView: PropTypes.func
};

InstitutionIdType.defaultProps = {
  view: '',
  isPublishModalOpen: false,
  isDeleteModalOpen: false,
  onPublish: undefined,
  handlePublishModalOpen: undefined,
  handlePublishModalClose: undefined,
  handleDeleteClick: undefined,
  handleDeleteModalClose: undefined,
  handleConfirmDelete: undefined,
  toggleEditView: undefined
};

export default InstitutionIdType;
